import { HttpClient } from '@opallabs/api'
import removeJsonApiEntities from '../removeJsonApiEntities'

const deleteContent = (id) => HttpClient().delete(`/content/v2/${id}`)

const destroyContent = (contentId, momentId) => (dispatch) =>
  deleteContent(contentId)
    .then((response) => {
      if (response.status === 202) {
        dispatch(
          removeJsonApiEntities({
            type: 'content',
            id: contentId,
            directRelationship: {
              key: 'posts',
              id: momentId,
              type: 'moment',
            },
          })
        )
      }
      return null
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destroyContent
